'use strict';
define(['app'], function (app) {
    app.component('stTrafficMetrics', {
        templateUrl: 'app/components/st-traffic-metrics/st-traffic-metrics.html',
        bindings: {
            organic: '<',
            value: '<',
            top3: '<',
            top10: '<',
            loading: '<'
        },
        controller: ['$translate', function ($translate) {
            var ctrl = this;

            function compactNumber(value) {
                var amount = Number(value) || 0;
                if (Math.abs(amount) >= 1000000000) {
                    return (amount / 1000000000).toFixed(1).replace('.', ',') + 'B';
                }
                if (Math.abs(amount) >= 1000000) {
                    return (amount / 1000000).toFixed(1).replace('.', ',') + 'M';
                }
                if (Math.abs(amount) >= 1000) {
                    return (amount / 1000).toFixed(1).replace('.', ',') + 'K';
                }
                return Math.round(amount).toLocaleString($translate.use() || 'en-US');
            }

            ctrl.number = compactNumber;
            ctrl.currency = function (value) {
                var amount = Number(value) || 0;
                try {
                    return new Intl.NumberFormat($translate.use() || 'en-US', {
                        style: 'currency',
                        currency: 'USD',
                        notation: 'compact',
                        maximumFractionDigits: 1
                    }).format(amount);
                } catch (error) {
                    return '$' + compactNumber(amount);
                }
            };
        }]
    });
});
